// Легенда драфт-слоя «Вероятные призраки»: обозначения, тумблеры кругов точности и статусов
import { t } from '@lingui/macro';
import classnames from 'classnames';
import { connect } from 'react-redux';
import React from 'react';
import {
    onToggleGhostDevicesShowAccuracy,
    onToggleGhostDevicesShowChangeBattery,
    onToggleGhostDevicesShowFinishAccuracy,
    onToggleGhostDevicesShowStandBy,
} from '../../../ac/onChangeMapFilters';
import {
    GHOST_DEVICES_COLOR_CHANGE_BATTERY,
    GHOST_DEVICES_COLOR_LIKELY,
    GHOST_DEVICES_COLOR_SHOWN,
    GHOST_DEVICES_LAYER_ID,
} from '../../../constants/layers';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import styles from '../FilterSidebar.module.css';

const Icon = ({ children }) => (
    <svg
        viewBox="0 0 24 24"
        style={{ display: 'block' }}
    >{children}</svg>
);
const Switch = ({ id, checked, onChange }) => (
    <div>
        <label className={styles.switch}>
            <input
                type='checkbox'
                id={id}
                checked={checked}
                onChange={onChange}
            />
            <span className={classnames(styles.sliderRound, styles.slider)} />
        </label>
    </div>
);
const AccuracyIcon = ({ color }) => (
    <Icon>
        <circle
            cx="12"
            cy="12"
            r="11"
            fill={color}
            fillOpacity="0.15"
            stroke={color}
            strokeWidth="1.5"
        />
        <circle
            cx="12"
            cy="12"
            r="4"
            fill={color}
            stroke="#fff"
            strokeWidth="1"
        />
    </Icon>
);
// точка «где показан» в цвете статуса
const StatusIcon = ({ color }) => (
    <Icon>
        <circle
            cx="12"
            cy="12"
            r="9"
            fill="#fff"
            stroke={color}
            strokeWidth="3"
        />
    </Icon>
);
const GhostDevicesLegendComponent = ({
    mapFilters,
    onToggleGhostDevicesShowAccuracy,
    onToggleGhostDevicesShowFinishAccuracy,
    onToggleGhostDevicesShowStandBy,
    onToggleGhostDevicesShowChangeBattery,
}) => (
    <div>
        <div className={styles.legHead}>{t`Вероятные призраки:`}</div>
        <div className={classnames(styles.checkboxIconGrid, styles.checkboxIconGridLarge)}>
            <Icon>
                <circle
                    cx="12"
                    cy="12"
                    r="9"
                    fill="#fff"
                    stroke={GHOST_DEVICES_COLOR_SHOWN}
                    strokeWidth="3"
                />
            </Icon>
            <span>{t`Где показан в приложении`}</span>
            <div />
            <Icon>
                <circle
                    cx="12"
                    cy="12"
                    r="10"
                    fill={GHOST_DEVICES_COLOR_LIKELY}
                    stroke="#fff"
                    strokeWidth="1"
                />
            </Icon>
            <span>{t`Вероятно стоит здесь (финиш)`}</span>
            <div />
            <Icon>
                <line
                    x1="1"
                    y1="12"
                    x2="23"
                    y2="12"
                    stroke={GHOST_DEVICES_COLOR_SHOWN}
                    strokeWidth="3"
                    strokeDasharray="4 3"
                />
            </Icon>
            <span>{t`Смещение позиции`}</span>
            <div />
            <AccuracyIcon color={GHOST_DEVICES_COLOR_SHOWN} />
            <label htmlFor="ghostDevicesShowAccuracy">{t`Круг точности: где показан (до 2 км)`}</label>
            <Switch
                id="ghostDevicesShowAccuracy"
                checked={mapFilters.ghostDevicesShowAccuracy}
                onChange={onToggleGhostDevicesShowAccuracy}
            />
            <AccuracyIcon color={GHOST_DEVICES_COLOR_LIKELY} />
            <label htmlFor="ghostDevicesShowFinishAccuracy">{t`Круг точности: финиш (самокат ↔ телефон)`}</label>
            <Switch
                id="ghostDevicesShowFinishAccuracy"
                checked={mapFilters.ghostDevicesShowFinishAccuracy}
                onChange={onToggleGhostDevicesShowFinishAccuracy}
            />
        </div>
        <div
            className={styles.legHead}
            style={{ marginTop: '8px' }}
        >{t`Статусы:`}</div>
        <div className={classnames(styles.checkboxIconGrid, styles.checkboxIconGridLarge)}>
            <StatusIcon color={GHOST_DEVICES_COLOR_SHOWN} />
            <label htmlFor="ghostDevicesShowStandBy">{t`STAND_BY`}</label>
            <Switch
                id="ghostDevicesShowStandBy"
                checked={mapFilters.ghostDevicesShowStandBy}
                onChange={onToggleGhostDevicesShowStandBy}
            />
            <StatusIcon color={GHOST_DEVICES_COLOR_CHANGE_BATTERY} />
            <label htmlFor="ghostDevicesShowChangeBattery">{t`CHANGE_BATTERY`}</label>
            <Switch
                id="ghostDevicesShowChangeBattery"
                checked={mapFilters.ghostDevicesShowChangeBattery}
                onChange={onToggleGhostDevicesShowChangeBattery}
            />
        </div>
        <div style={{ marginTop: '6px', fontSize: '0.85em', opacity: 0.8 }}>
            {t`Самокат показан дальше 300 м от финиша последней поездки, а на финише самокат и телефон совпали: примерно в половине случаев самоката на показанной точке нет.`}
        </div>
    </div>
);
const mapStateToProps = ({ mapFilters }) => ({ mapFilters });
const ConnectedComponent = connect(mapStateToProps, {
    onToggleGhostDevicesShowAccuracy,
    onToggleGhostDevicesShowFinishAccuracy,
    onToggleGhostDevicesShowStandBy,
    onToggleGhostDevicesShowChangeBattery,
})(GhostDevicesLegendComponent);

export const GhostDevicesLegend = withDisplayedLayersCheck(
    ConnectedComponent,
    GHOST_DEVICES_LAYER_ID
);
